function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 26,
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m 17.756887,5.2066654 c 0,2.06558 -3.6994,3.54805 -8.2627997,3.54805 -4.56344,0 -8.26283,-1.48247 -8.26283,-3.54805 m 16.5256297,0 c 0,-2.06558 -3.6994,-3.54805 -8.2627997,-3.54805 -4.56344,0 -8.26283,1.48247 -8.26283,3.54805 m 16.5256297,0 V 20.108495 c 0,2.2131 -3.3734,4.2576 -8.2627997,4.2576 -4.8894,0 -8.26283,-2.0445 -8.26283,-4.2576 V 5.2066654",
    stroke: "#ffffff",
    strokeWidth: 2.3,
    id: "path1",
    style: {
      stroke: "#ffffff",
      strokeWidth: 2.4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDb);
export default __webpack_public_path__ + "static/media/db.112864d9151edc6c1705a7907c417983.svg";
export { ForwardRef as ReactComponent };